import { useState } from "react";
import ContractTableStyle from "./Table.module.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import Tooltip from "../Tooltip/Tooltip";
import useContractTable from "../../hooks/useContractTable";
import Loader from "../Loader/Loader";
import UserActionEditIcon from "../../assets/images/UserTable/Icon_Button.svg";
import PowerUserTickSVG from "../../assets/images/UserTable/powerUserTick.svg";
import PowerUserCrossSVG from "../../assets/images/UserTable/powerUserCross.svg";
import ascActiveSortSvg from "../../assets/asc_active.svg";
import descActiveSortSvg from "../../assets/desc_active.svg";

import ascInactiveSortSvg from "../../assets/asc_inactive.svg";
import descInactiveSortSvg from "../../assets/desc_inactive.svg";

import InfoIconSVG from "../../assets/images/UserTable/InfoIcon.svg";

import {
  TableTypes,
  PaginationActions,
  SORT,
  TABLECELL,
  tableConfiguration,
} from "../../modules/ManageContract/constants";
import Badge from "../Badge/Badge";

import { StatusPill } from "../StatusPill/StatusPill";
import { Pagination } from "../Pagination/Pagination";
import NoData from "../NoData/NoData";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import {
  getTableDataThunk,
  updateSortByForTableThunk,
} from "../../store/thunks/table.thunk";
import { ROUTES } from "../../common/constants";
import { getLocalDateTimeFromTimestamp } from "../../common/utils";
import { UserRolesKey, UserRoleTagLine } from "../../modules/Admin/constants";
import PowerUserBadge from "../PowerUserBadge/PowerUserBadge";
import { ImageBadgeName } from "../../common/common";
import { Fragment } from "react/jsx-runtime";
import Typography from "../Typography/Typography";
import EllipsesText from "../../modules/vscDashboard/components/EllipsisText/EllipsisText";
import { StatusPillBU } from "../StatusPill/StatusPillBU";
import linkSvg from "../../assets/Link.svg";
import parentChildRelationIcon from "../../assets/images/parentChildRelationshipIcon.svg";

interface ContractTablePropTypes {
  entity: string;
  apiProps: {};
  poling?: boolean;
  updateModelData?: any;
  handleEditClick?: any;
  tableConfig?: any;
  emptyMessage?: string;
}

const TableHead = ({ column, allRoles }: any) => {
  const TooltipContent = () => {
    return (
      <div
        style={{
          display: "flex",
          width: "fit-content",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {allRoles
          ?.filter((role: any) => role?.name !== UserRolesKey.ADMIN)
          ?.map((role: any) => {
            return (
              <div>
                <p style={{ color: "#9E9E9E" }}>{role?.display_name}</p>
                <span>{role?.description}</span>
              </div>
            );
          })}
      </div>
    );
  };
  switch (column?.type) {
    case TABLECELL.USER_ROLES:
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {" "}
          <span>{column?.title} </span>
          {/* <Tooltip title={<TooltipContent />} placement={"right"}>
            <img src={InfoIconSVG} alt="" />
          </Tooltip> */}
        </div>
      );

    default:
      return (
        <span className={ContractTableStyle.headerTruncate}>
          {column?.title}
        </span>
      );
  }
};

const TableCell = ({
  column,
  tableCellData,
  tableType,
  handleEditClick,
  updateModelData,
  allRoles,
  entity,
  toggleRowExpansion,
  rowIndex, // Added for View column
}: any) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // const clauseDetails = tableCellData[column?.key];
  const parentDetails = tableCellData.parent_details?.clause_check_details;
  const parentDocName = tableCellData.parent_details?.display_name;
  const handleTitleClick = (id: string) => {
    let url = ROUTES.clauseCheckDoc + "?url=" + id;
    if (tableType === TableTypes.BULK_SUMMARY) {
      navigate(
        url +
          "&backurl=" +
          ROUTES.clauseSummary +
          "&type=" +
          tableType +
          (searchParams ? `&${searchParams.toString()}` : "")
      );
    } else if (tableType === TableTypes.DRAFTING_DASHBOARD) {
      navigate(
        url + "&backurl=" + ROUTES.contractDrafting + "&type=" + tableType
      );
    } else if (tableType === TableTypes.RFX_EVALUATION_DASHBOARD) {
      navigate(ROUTES.rfxEvaluation + "?productId=" + id);
    } else if (tableType === TableTypes.RFX_GENERATOR_DASHBOARD) {
      navigate(url + "&backurl=" + ROUTES.rfxGenerator + "&type=" + tableType);
    } else {
      url = `${ROUTES.doc}?url=${id}&backurl=${ROUTES.manageContracts}&tab=${entity}`;
      if (
        entity === TableTypes.REVEIW_COMPLETED ||
        entity === TableTypes.REVIEW_PENDING ||
        entity === TableTypes.REVIEW_PENDING_DASHBOARD
      ) {
        navigate(url);
      }
    }
  };

  const userData = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer?.details
  );

  const isLoggedInUser = tableCellData?.email === userData?.email;

  const dropdownOptions = [
    {
      key: "edit role",
      label: <span>Manage Role</span>,
      onClick: () => {
        handleEditClick(tableCellData);
        updateModelData(tableCellData);
      },
    },
  ];

  const handleEditUser = () => {
    handleEditClick(tableCellData);
    updateModelData(tableCellData);
  };

  switch (column?.type) {
    case TABLECELL.TOOLTIP:
      return (
        <td
          className={`${ContractTableStyle.filetab}  ${
            ContractTableStyle?.[tableType]
          } ${ContractTableStyle?.[column?.key]}`}
        >
          <EllipsesText tooltipContent={tableCellData[column?.key]}>
            <span
              onClick={() =>
                handleTitleClick(
                  tableType === TableTypes.DRAFTING_DASHBOARD
                    ? tableCellData?.driveId
                    : tableType === TableTypes.RFX_GENERATOR_DASHBOARD
                    ? tableCellData?.outputFileDriveId
                    : tableCellData?.id
                )
              }
              style={{
                cursor: "pointer",
              }}
            >
              {tableCellData[column?.key]}
            </span>
          </EllipsesText>
        </td>
      );

    case TABLECELL.CONTRACT_ID_TOOLTIP:
      const docId = tableCellData?.documentId;
      const simbaId = tableCellData?.simbaId;
      const sowId = tableCellData?.contractId;
      const data = [
        { key: "Docusign ID", value: docId },
        { key: "Simba ID", value: simbaId },
        { key: "SOW/MSOW Number", value: sowId },
      ];
      const content = (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {data?.map(
            (item: any) =>
              item?.value &&
              item?.value !== "N/A" && (
                <div style={{ display: "flex", gap: "12px" }}>
                  <p style={{ color: "#9E9E9E" }}>{item?.key}:</p>
                  <span>{item?.value}</span>
                </div>
              )
          )}
        </div>
      );

      const val =
        docId && docId !== "N/A"
          ? docId
          : simbaId && simbaId !== "N/A"
          ? simbaId
          : sowId && sowId !== "N/A"
          ? sowId
          : "N/A";

      return (
        <td
          className={`${ContractTableStyle?.[tableType]} ${
            ContractTableStyle?.[column?.key]
          }`}
        >
          <Tooltip title={content || "N/A"}>{val}</Tooltip>
        </td>
      );

    case TABLECELL.BADGE:
      return (
        <td>
          <Badge
            data={tableCellData[column?.key]}
            parentData={parentDetails}
            parentDocName={parentDocName}
          />
        </td>
      );

    case TABLECELL.PILL:
      return (
        <td>
          <StatusPill status={tableCellData[column?.key]} />
        </td>
      );

    case TABLECELL.PILLBU:
      return (
        <td>
          <StatusPillBU status={tableCellData[column?.key]} />
        </td>
      );

    case TABLECELL.VENDORANDDOC:
      return (
        <td className={ContractTableStyle.filetab}>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Tooltip title={tableCellData[column.key]?.vendor}>
              <span style={{ whiteSpace: "nowrap" }}>
                {tableCellData[column.key]?.vendor}
              </span>
            </Tooltip>
            {tableCellData.is_parent_present && (
              <img
                src={linkSvg}
                alt="Has Parent"
                style={{
                  width: "10px",
                  height: "10px",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
                onClick={toggleRowExpansion}
              />
            )}
          </div>
          <span
            className={ContractTableStyle.docType}
            style={{ fontSize: "11px", fontWeight: "400", color: "#00000066" }}
          >
            <span
              style={{
                fontSize: "11px",
                fontWeight: "400",
                color: "#00000066",
              }}
            >
              Type:{" "}
            </span>
            <span
              style={{
                fontSize: "11px",
                fontWeight: "400",
                color: "#00000066",
                whiteSpace: "nowrap",
              }}
            >
              {" "}
              {tableCellData[column.key]?.docType}
            </span>
          </span>
        </td>
      );

    case TABLECELL.DATEANDTIME:
      return (
        <td className={ContractTableStyle.filetab}>
          {tableCellData[column.key]?.date}

          <span
            className={ContractTableStyle.docType}
            style={{ fontSize: "11px", fontWeight: "400", color: "#00000066" }}
          >
            <span
              style={{
                fontSize: "11px",
                fontWeight: "400",
                color: "#00000066",
              }}
            >
              {" "}
              {tableCellData[column.key]?.time}
            </span>
          </span>
        </td>
      );

    case TABLECELL.USER_ROLES:
      return (
        <td className={ContractTableStyle?.[column?.key]}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
            {tableCellData[column?.key]?.map((role: any) => {
              return (
                <>
                  <div className={ContractTableStyle.content}>
                    <div className={ContractTableStyle.roleCard}>
                      <Tooltip
                        placement="bottom"
                        title={UserRoleTagLine?.[role?.name]}
                      >
                        <span className={ContractTableStyle.name}>
                          {role?.display_name}
                        </span>
                      </Tooltip>
                      {/* <span className={ContractTableStyle.tagLine}>
                        {role?.description}
                      </span> */}
                    </div>
                    {/* <Tooltip placement="top" title={TooltipContent}>
                      <img src={InfoIconSVG} alt="" />
                    </Tooltip> */}
                  </div>
                </>
              );
            })}
            {/* {getRoles(tableCellData[column?.key])} */}
          </div>
        </td>
      );

    case TABLECELL.USER_ACTIONS:
      return (
        <td className={ContractTableStyle?.[column?.key]}>
          <span>
            {isLoggedInUser ? (
              <></>
            ) : (
              <img onClick={handleEditUser} src={UserActionEditIcon} alt="" />
            )}
          </span>
        </td>
      );

    case TABLECELL.POWER_USER:
      return (
        <td className={ContractTableStyle?.[column?.key]}>
          <span>
            {tableCellData[column?.key] ? (
              <img src={PowerUserTickSVG} alt="" />
            ) : (
              <img src={PowerUserCrossSVG} alt="" />
            )}
          </span>
        </td>
      );

    case TABLECELL.USER_PROFILE:
      const TooltipContent = allRoles?.filter(
        (item: any) => item?.name === UserRolesKey.ADMIN
      )[0]?.description;
      return (
        <td className={ContractTableStyle?.[column?.key]}>
          <div className={ContractTableStyle.content}>
            {/* <img
              className={ContractTableStyle.userImg}
              src={tableCellData[column?.key]?.image}
              alt="user-img"
            /> */}
            <ImageBadgeName
              name={tableCellData[column?.key]?.name}
              url={tableCellData[column?.key]?.image}
            />
            <div className={ContractTableStyle.text}>
              <span>{tableCellData[column?.key]?.name}</span>
              {tableCellData[column?.key]?.isPowerUser && (
                <div className={ContractTableStyle.tag}>
                  <PowerUserBadge className={ContractTableStyle.badge} />
                  {/* <Tooltip placement="right" title={TooltipContent}>
                    <img src={InfoIconSVG} alt="" />
                  </Tooltip> */}
                </div>
              )}
            </div>
          </div>
        </td>
      );
    case TABLECELL.ELLIPSIS_TEXT:
      const ellipsisContent = <span>{tableCellData[column?.key]}</span>;
      return (
        <td className={ContractTableStyle?.[column?.key]}>
          <EllipsesText
            tooltipContent={<Typography>{ellipsisContent}</Typography>}
          >
            {ellipsisContent}
          </EllipsesText>
        </td>
      );

    case TABLECELL.DATE:
      return (
        <td className={ContractTableStyle?.[column?.key]}>
          {
            getLocalDateTimeFromTimestamp({
              timestamp: tableCellData[column?.key],
            }).date
          }
        </td>
      );

    case TABLECELL.VIEW:
      // Show eye icon for rows which have status 'draft' or any reviewing status
      // Normalize status to match how StatusPillBU does it
      const statusLower = (tableCellData.status || "").toString().toLowerCase().replaceAll(/\s+/g, '_');
      
      // Debug log to see actual status values
      console.log('View column - Original status:', tableCellData.status, 'Normalized:', statusLower);
      
      // Check for draft, reviewing statuses, or submitted for approval
      const isDraft = statusLower === "draft";
      const isReviewing = 
        statusLower === "meta_extraction_in_progress" ||
        statusLower === "assigning_category_manager" ||
        statusLower.includes("review");
      const isSubmittedForApproval = statusLower === "submitted_for_approval";
      
      const shouldShowEye = isDraft || isReviewing || isSubmittedForApproval;
      const hasDocId2 = !!tableCellData.doc_id;
      const docLink2 = tableCellData.document_drive_link;
      
      console.log('View column - isDraft:', isDraft, 'isReviewing:', isReviewing, 'isSubmittedForApproval:', isSubmittedForApproval, 'shouldShowEye:', shouldShowEye, 'hasDocId:', hasDocId2);
      
      return (
        <td className={ContractTableStyle?.[column?.key]} style={{ textAlign: "center" }}>
          {shouldShowEye ? (
            hasDocId2 ? (
              <img
                src={require("../../assets/view-eye.svg").default}
                alt="View"
                style={{ width: 20, height: 20, cursor: "pointer" }}
                onClick={() => {
                  // For sourcing hub flow, use URL params similar to contract review flow
                  const backUrl = `/workbench-dashboard`;
                  
                  // Determine tab based on status:
                  // - draft -> review_not_started
                  // - statuses that include "review" -> review_inprogress
                  // - "Submitted For Approval" or "submitted_for_approval" -> review_completed
                  // - otherwise -> review_completed
                  const status = (tableCellData.status || "").toString().toLowerCase().replaceAll(/\s+/g, '_');
                  let tab = "review_completed";
                  if (status === "draft") {
                    tab = "review_not_started";
                  } else if (status.includes("review")) {
                    tab = "review_inprogress";
                  } else if (status === "submitted_for_approval") {
                    tab = "review_completed";
                  }

                  navigate(`/contracts?url=${tableCellData.doc_id}&backurl=${backUrl}&tab=${tab}`, {
                    state: {
                      documentLink: docLink2,
                      docId: tableCellData.doc_id,
                    },
                  });
                }}
              />
            ) : (
              <img
                src={require("../../assets/view-eye.svg").default}
                alt="View"
                style={{ width: 20, height: 20, opacity: 0.4 }}
              />
            )
          ) : null}
        </td>
      );
    default:
      return (
        <td className={ContractTableStyle?.[column?.key]}>
          {tableCellData[column?.key]}
        </td>
      );
  }
};

const Table = ({
  entity,
  apiProps,
  emptyMessage,
  poling,
  updateModelData,
  handleEditClick,
  tableConfig,
}: ContractTablePropTypes) => {
  const [highlightedRows, setHighlightedRows] = useState<Set<number>>(
    new Set()
  );
  const [expandedRows, setExpandedRows] = useState(new Set());
  const handleRowExpansion = (rowIndex: number) => {
    const newExpandedRows = new Set(expandedRows);
    const newHighlightedRows = new Set(highlightedRows);

    if (newExpandedRows.has(rowIndex)) {
      newExpandedRows.delete(rowIndex);
      newHighlightedRows.delete(rowIndex);
    } else {
      newExpandedRows.add(rowIndex);
      newHighlightedRows.add(rowIndex);
    }

    setExpandedRows(newExpandedRows);
    setHighlightedRows(newHighlightedRows);
  };

  const rolesData = useAppSelector(
    (store) => store?.rootReducer?.userInfoReducer?.rolesData
  );
  const allAvailableRoles = rolesData?.data;

  const { contractsReview, contractDrafting } = useAppSelector(
    (state) => state.rootReducer.vscDashboardReducer
  );

  // If provide config is undefined, it takes the default configureation
  const tableColumns = tableConfig
    ? tableConfig?.tableColumns
    : tableConfiguration?.[entity]?.tableColumns;

  const [
    tabledata,
    pageNumber,
    setPageNumber,
    toBeRetrieved,
    setToBeRetrieved,
    loading,
    error,
  ] = useContractTable({
    entity: entity,
    apiProps: apiProps,
    poling: poling,
  });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const entityData = useAppSelector(
    (state) => state.rootReducer.tableInfoReducer
  )?.data?.[entity];

  const clauseCheckOrRedliningDashboard =
    entity === TableTypes.REVIEW_PENDING_DASHBOARD ||
    entity === TableTypes.BULK_CLAUSE_DASHBOARD ||
    entity === TableTypes.DRAFTING_DASHBOARD ||
    entity === TableTypes.RFX_EVALUATION_DASHBOARD ||
    entity === TableTypes.RFX_GENERATOR_DASHBOARD;

  const redliningUploadingFile =
    entity === TableTypes.REVIEW_PENDING_DASHBOARD &&
    contractsReview?.pending_documents?.fileUpload?.isUploading;

  // const draftingUploadingFile =
  //   entity === TableTypes.DRAFTING_DASHBOARD &&
  //   contractDrafting?.fileUpload?.isUploading;

  const fileNameWhileUploading =
    contractsReview?.pending_documents?.list[0]?.display_name;

  const handleButtonClick = (action: string) => {
    // Added this to prevent api calls while new data is being fetched
    if (!entityData?.newDataRequested) {
      switch (action) {
        case PaginationActions.FIRST:
          setPageNumber(1);
          break;
        case PaginationActions.PREVIOUS:
          setPageNumber(pageNumber - 1);
          break;

        case PaginationActions.NEXT:
          setPageNumber(pageNumber + 1);
          break;

        case PaginationActions.LAST:
          setPageNumber(Math.ceil(tabledata?.count / toBeRetrieved));
          break;
      }
    }
  };

  const handleCountChange = (value: number) => {
    setPageNumber(1);
    setToBeRetrieved(value);
  };

  const handleSort = async (col: any, sortDirection: string) => {
    const isAlreadySelected =
      col?.category === entityData?.sort_by?.field &&
      sortDirection === entityData?.sort_by?.order;

    let sort_by = {};
    if (!isAlreadySelected) {
      sort_by = {
        field: col?.category,
        order: sortDirection,
      };
    }

    await dispatch(
      updateSortByForTableThunk({
        entity: entity,
        sort_by: sort_by,
      })
    );
    dispatch(
      getTableDataThunk(entity, pageNumber, toBeRetrieved, {
        ...apiProps,
        sort_by: sort_by,
      })
    );
  };

  return (
    <>
      {" "}
      <div
        className={`${ContractTableStyle.tableWrapper} ${
          clauseCheckOrRedliningDashboard
            ? ContractTableStyle.dashboradTableWrapper
            : ""
        }`}
      >
        <div className={ContractTableStyle.tableScrollContainer}>
          <table
            className={`${ContractTableStyle.ctable} ${ContractTableStyle?.[entity]}`}
            style={loading || tabledata?.count === 0 ? { height: "100%" } : {}}
          >
            <thead>
              <tr>
                {tableColumns?.map((col: any) => {
                  const isActiveSorter =
                    entityData?.sort_by?.field === col?.category;
                  const isActiveAscSorter =
                    isActiveSorter && entityData?.sort_by?.order === SORT.ASC;
                  const isActiveDescSorter =
                    isActiveSorter && entityData?.sort_by?.order === SORT.DESC;
                  return (
                    <th>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <span
                          style={{
                            width: "100%",
                            maxWidth: "150px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          className={ContractTableStyle?.[col?.key]}
                          title={col?.title}
                        >
                          <TableHead
                            column={col}
                            allRoles={allAvailableRoles}
                          />
                          {/* {col?.title === "null" ? "\u00A0" : col?.title} */}
                        </span>
                        {col?.withSorting && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              cursor: "pointer",
                              gap: "2px",
                              width: "10%",
                              height: "10px",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={
                                isActiveAscSorter
                                  ? ascActiveSortSvg
                                  : ascInactiveSortSvg
                              }
                              alt=""
                              height="8px"
                              width="10px"
                              onClick={() => handleSort(col, SORT.ASC)}
                            />
                            <img
                              src={
                                isActiveDescSorter
                                  ? descActiveSortSvg
                                  : descInactiveSortSvg
                              }
                              alt=""
                              height="8px"
                              width="10px"
                              onClick={() => handleSort(col, SORT.DESC)}
                            />
                          </div>
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={tableColumns?.length}>
                    <Loader />
                  </td>
                </tr>
              ) : tabledata?.count === 0 || error ? (
                redliningUploadingFile ? (
                  <tr
                    className={`${ContractTableStyle?.[entity]} ${ContractTableStyle.loadingRows}`}
                  >
                    {tableColumns?.map((element: any, colIndex: number) => (
                      <TableCell
                        key={colIndex}
                        column={element}
                        tableCellData={{
                          vendorName: "N/A",
                          file: fileNameWhileUploading,
                          contractType: "N/A",
                          mtc: "N/A",
                        }}
                        tableType={entity}
                        handleEditClick={handleEditClick}
                        updateModelData={updateModelData}
                        allRoles={allAvailableRoles}
                      />
                    ))}
                  </tr>
                ) : entity === TableTypes.DRAFTING_DASHBOARD ? (
                  <tr>
                    <td colSpan={tableColumns?.length}>
                      <Typography
                        fontWeight={400}
                        fontSize={11}
                        color="#3474E0"
                        fontStyle={"italic"}
                      >
                        You have 0 contracts generated
                      </Typography>
                    </td>
                  </tr>
                ) : entity === TableTypes.RFX_GENERATOR_DASHBOARD ? (
                  <tr>
                    <td colSpan={tableColumns?.length}>
                      <Typography
                        fontWeight={400}
                        fontSize={11}
                        color="#3474E0"
                        fontStyle={"italic"}
                      >
                        {emptyMessage || "You have 0 RFx generated"}
                      </Typography>
                    </td>
                  </tr>
                ) : entity === TableTypes.RFX_EVALUATION_DASHBOARD ? (
                  <tr>
                    <td colSpan={tableColumns?.length}>
                      <Typography
                        fontWeight={400}
                        fontSize={11}
                        color="#3474E0"
                        fontStyle={"italic"}
                      >
                        You have 0 evaluated RFx
                      </Typography>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td
                      style={{ padding: "50px" }}
                      colSpan={tableColumns?.length}
                    >
                      <NoData />
                    </td>
                  </tr>
                )
              ) : (
                tabledata?.results?.map((item: any, rowIndex: number) => (
                  <Fragment key={rowIndex}>
                    {redliningUploadingFile && rowIndex === 0 && (
                      <tr
                        className={`${ContractTableStyle?.[entity]} ${ContractTableStyle.loadingRows}`}
                      >
                        {tableColumns?.map((element: any, colIndex: number) => (
                          <TableCell
                            key={colIndex}
                            column={element}
                            tableCellData={{
                              ...item,
                              vendorName: "N/A",
                              file: contractsReview?.pending_documents?.list[0]
                                ?.display_name,
                              contractType: "N/A",
                              mtc: "N/A",
                            }}
                            tableType={entity}
                            handleEditClick={handleEditClick}
                            updateModelData={updateModelData}
                            allRoles={allAvailableRoles}
                          />
                        ))}
                      </tr>
                    )}
                    <tr
                      className={`${ContractTableStyle?.[entity]} ${
                        highlightedRows.has(rowIndex)
                          ? ContractTableStyle.expandedRow
                          : ""
                      } ${
                        rowIndex === 0 ? ContractTableStyle.tableBodyRow : ""
                      }`}
                    >
                      {tableColumns?.map((element: any, colIndex: number) => (
                        <TableCell
                          key={colIndex}
                          column={element}
                          tableCellData={item}
                          tableType={entity}
                          handleEditClick={handleEditClick}
                          updateModelData={updateModelData}
                          allRoles={allAvailableRoles}
                          entity={entity}
                          toggleRowExpansion={() =>
                            handleRowExpansion(rowIndex)
                          }
                          rowIndex={colIndex === tableColumns.length - 1 ? rowIndex : rowIndex} // Pass rowIndex for all, but especially for View column
                        />
                      ))}
                    </tr>
                    {expandedRows.has(rowIndex) && item.parent_details && (
                      <tr
                        className={`${ContractTableStyle?.[entity]} ${ContractTableStyle.parentRow}`}
                      >
                        {tableColumns?.map((element: any, colIndex: number) => {
                          if (colIndex === 0) {
                            return (
                              <td
                                key={colIndex}
                                style={{
                                  position: "relative",
                                  paddingLeft: "16px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={parentChildRelationIcon}
                                  alt="Parent-Child"
                                  style={{
                                    position: "relative",
                                    transform: "translateY(-50%)",
                                    height: "39px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleRowExpansion(rowIndex)}
                                />

                                <TableCell
                                  column={element}
                                  key={colIndex}
                                  tableCellData={(() => {
                                    const parentDataInput = item.parent_details;
                                    const clauseCheckDetailsArr =
                                      parentDataInput.clause_check_details ||
                                      [];
                                    const clauseCheckDetailsMap =
                                      clauseCheckDetailsArr.reduce(
                                        (
                                          acc: { [x: string]: any },
                                          el: { category: string | number }
                                        ) => {
                                          acc[el.category] = el;
                                          return acc;
                                        },
                                        {}
                                      );
                                    return {
                                      id: parentDataInput.id,
                                      vendorWithType: {
                                        vendor:
                                          parentDataInput.metadata
                                            ?.vendor_name ||
                                          parentDataInput.display_name,
                                        docType:
                                          parentDataInput.metadata
                                            ?.engagement_name ||
                                          parentDataInput.metadata
                                            ?.contract_type,
                                      },
                                      title: parentDataInput.metadata?.title,
                                      contractId:
                                        parentDataInput.metadata?.contract_id,
                                      earnBack:
                                        clauseCheckDetailsMap[
                                          "SLA Penalties/Earn Back"
                                        ],
                                      volumeDiscount:
                                        clauseCheckDetailsMap[
                                          "Volume Discounts"
                                        ],
                                      investments:
                                        clauseCheckDetailsMap[
                                          "Non-EPP Investments"
                                        ],
                                      prodImprove:
                                        clauseCheckDetailsMap[
                                          "Productivity Improvements"
                                        ],
                                      benchRecommendation:
                                        clauseCheckDetailsMap[
                                          "Committed Buffer/Bench Pool"
                                        ],
                                      overtime:
                                        clauseCheckDetailsMap[
                                          "Overtime/On-call & Holiday Bill Rates"
                                        ],
                                    };
                                  })()}
                                  tableType={entity}
                                  handleEditClick={handleEditClick}
                                  updateModelData={updateModelData}
                                  allRoles={allAvailableRoles}
                                  entity={entity}
                                />
                              </td>
                            );
                          }
                          // All other cells as before
                          return (
                            <TableCell
                              key={colIndex}
                              column={element}
                              tableCellData={(() => {
                                const parentDataInput = item.parent_details;
                                const clauseCheckDetailsArr =
                                  parentDataInput.clause_check_details || [];
                                const clauseCheckDetailsMap =
                                  clauseCheckDetailsArr.reduce(
                                    (
                                      acc: { [x: string]: any },
                                      el: { category: string | number }
                                    ) => {
                                      acc[el.category] = el;
                                      return acc;
                                    },
                                    {}
                                  );
                                return {
                                  id: parentDataInput.id,
                                  vendorWithType: {
                                    vendor:
                                      parentDataInput.metadata?.vendor_name ||
                                      parentDataInput.display_name,
                                    docType:
                                      parentDataInput.metadata
                                        ?.engagement_name ||
                                      parentDataInput.metadata?.contract_type,
                                  },
                                  title: parentDataInput.metadata?.title,
                                  contractId:
                                    parentDataInput.metadata?.contract_id,
                                  earnBack:
                                    clauseCheckDetailsMap[
                                      "SLA Penalties/Earn Back"
                                    ],
                                  volumeDiscount:
                                    clauseCheckDetailsMap["Volume Discounts"],
                                  investments:
                                    clauseCheckDetailsMap[
                                      "Non-EPP Investments"
                                    ],
                                  prodImprove:
                                    clauseCheckDetailsMap[
                                      "Productivity Improvements"
                                    ],
                                  benchRecommendation:
                                    clauseCheckDetailsMap[
                                      "Committed Buffer/Bench Pool"
                                    ],
                                  overtime:
                                    clauseCheckDetailsMap[
                                      "Overtime/On-call & Holiday Bill Rates"
                                    ],
                                };
                              })()}
                              tableType={entity}
                              handleEditClick={handleEditClick}
                              updateModelData={updateModelData}
                              allRoles={allAvailableRoles}
                              entity={entity}
                            />
                          );
                        })}
                      </tr>
                    )}
                  </Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>

        {tabledata?.count !== 0 && !error && (
          <Pagination
            type={tableConfiguration?.[entity]?.paginationType}
            entity={entity}
            count={toBeRetrieved}
            page={pageNumber}
            tableObject={tabledata || {}}
            handleButtonClick={handleButtonClick}
            handleCountChange={handleCountChange}
            className={
              clauseCheckOrRedliningDashboard
                ? ContractTableStyle.paginateAdvanceReviewPending
                : ""
            }
          />
        )}
      </div>
    </>
  );
};

export default Table;
